const halfPI = Math.PI * 0.5

export function lerp(start, end, amt, precision = 0.01) {
  let value = (1 - amt) * start + amt * end

  const diff = Math.abs(end - value)

  // if (diff < 0.001) {
  //     value = end
  // }

  return value
}

export function lerpfi(source, target, smoothing, dt = 0.016, precision = 0.01) {
  return lerp(source, target, 1 - Math.pow(Math.cos(halfPI * smoothing), dt), precision)
}